import request from "@/common/request";
import { Page, Cashback, ItemCashback } from "@/models";
import { AxiosRequestConfig } from "axios";

const basePath = '/cashBack'

export const findCashbackPorCliente = (params?: any, config?: AxiosRequestConfig): Promise<Page<Cashback>> =>
	request.get(`${basePath}`, { params, ...config })

export const findItensCashback = (params?: any, config?: AxiosRequestConfig): Promise<Page<ItemCashback>> =>
	request.get(`${basePath}/itens`, { params, ...config })

export const cancelar = (id: string): Promise<Cashback> =>
	request.put(`${basePath}/${id}`)